import { createSlice } from "@reduxjs/toolkit";

export const erpIntegrationCustomerSlice = createSlice({
  name: "erpIntegrationCustomer",
  initialState: {  
    selectedCustomer:{
      code: "",
      description: "",
      tckn : "", 
      id: -1,
      email : "",
      phone: "",
      orderid:-1
    }
  },
  reducers: { 
    onSelectErpIntegrationCustomer: (state, action) => {
      state.selectedCustomer = action.payload; 
      return state;
    },
    clearErpIntegrationCustomer: (state, action) => {
      state.selectedCustomer = {}; 
      return state;
    },
  },
});
export const { onSelectErpIntegrationCustomer, clearErpIntegrationCustomer } = erpIntegrationCustomerSlice.actions;

 

export const erpIntegrationReducer = erpIntegrationCustomerSlice.reducer;









